// extracted by mini-css-extract-plugin
export default {"title":"delete_title__1fLrp","itemName":"delete_itemName__zSqUL"};